import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";

const Register = () => {

    const [formData, setFormData] = useState({
        name : "",
        phonenumber : "",
        email: "",
        password : ""
    });
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    // console.log(error);


    const handleChange = (e) => {
        const { name, value} = e.target;
        setFormData(prev => ({
            ...prev, [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");

        try{
            const response = await fetch('https://api.welbeing.in/register/', {
                method : 'POST',
                headers : {
                    'Content-Type' : 'application/json',
                },
                body: JSON.stringify(formData)

            });
             
            const data = await response.json();

            //  console.log('Registration successfull:', data);


            if(data.status === 'success') {
                navigate('/login');
                // console.log('Registration successfull:', data.data.message);
            } else{
                setError(data.error.message);
            }
            }catch (err) {
                setError('Network error. Please try again.');          
        } finally{
            setIsLoading(false);
        }
    }
    return (
        <>
            <Header />
            <div className="main" style={{marginTop:'100px'}}>
                <section className="page-body p-5">
                    <div className="row g-0 ratio_asos p-5">
                        <div className="order-2 order-lg-1 col-lg-8 col-md-6 mt-5 p-5">
                            <div className="content-box">
                                <form onSubmit={handleSubmit} action="" className="custom-form form-pill" method="post">
                                    <div>
                                        <h5>CREATE ACCOUNT <span className="bg-theme-blue"></span></h5>

                                       
                                        
                                        <div className="input-box">
                                            <label htmlFor="name">Full Name</label>
                                            <input className="form-control" type="text" name="name" id="name" value={formData.name} onChange={handleChange} required />
                                        </div>
                                        
                                        <div className="input-box">
                                            <label htmlFor="phonenumber">Phone Number</label>
                                            <input className="form-control" type="tel" name="phonenumber" id="phonenumber" value={formData.phonenumber} onChange={handleChange} required />
                                        </div>
                                        
                                        <div className="input-box">
                                            <label htmlFor="email">Email</label>
                                            <input className="form-control" type="email" name="email" id="email" value={formData.email} onChange={handleChange} required />
                                        </div>

                                        <div className="input-box">
                                            <label htmlFor="password">Password</label>
                                            <div className="icon-input">
                                                <input className="form-control" type="password" name="password" id="password" value={formData.password} onChange={handleChange} required />
                                            </div>
                                        </div>

                                         {error && (
                                            <div className="alert alert-danger mt-2">{error}</div>
                                        )}

                                        <button type="submit" name="register" className="btn-solid rounded-pill line-none">
                                            Create an account <i className="arrow"></i>
                                        </button>
                                        <a href="/login" className="btn-solid rounded-pill line-none btn-outline mt-3 d-flex justify-content-center">
                                            Login <i className="arrow"></i>
                                        </a>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="order-1 order-lg-2 col-lg-4 col-md-6">
                            <div className="img-box">
                                <img className="img-fluid" src="assets/img/banner/login.png" alt="banner" style={{objectFit:'cover', height:'600px'}} />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    );
}

export default Register;